import React from 'react';
import { analyticsClickEvent } from '../../action/firebaseAnalytics/firebaseAnalytics';
import { PropTypes } from 'prop-types';
import IndustryImage from '../dashboard/home/industryImage';

class CategoryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  
            itemList:[],
            categoryClass:'category-img-Qed',
            Redirect:false
        }
        this.initialLoad =this.initialLoad.bind(this);
    }
    componentDidMount(){
        this.setState({itemList:this.props.itemList});
        this.initialLoad();
    }
    
    initialLoad(){
        this.props.clearCheckList();
    }
    
    categoryChange = (classes) => {//NOSONAR
        this.setState({ categoryClass: classes });
    }

    ClickEvent=(response)=>{
    //    analyticsClickEvent(response+'_partner')
       analyticsClickEvent('shop_partners',response)
        setTimeout(() => {
        this.setState({Redirect:true})
         this.props.redirectPage(this.state.Redirect,response);
        },100);
    
      
    }
    
    render() { 
        
        return (  
            <div className="category-gallery">
                <div className="category-unlist">   
            {this.state.itemList?.map(response =>
            <button className={`${this.state.categoryClass} btn-style`} type='button'  onClick={()=>{this.ClickEvent(response.industry_name)}} key={response.industry_name}>                
                <div className="category-img-sec">
                    <IndustryImage src={response.industry_image} industryName={response.industry_name} />
                    <div className="overlay">
                    </div>
                        <div className="cate-text">
                            <div className="w-100">
                                <span>{response.industry_name}</span>
                            </div>
                        </div>
                </div> 
            </button>   
             ) 
        } 
            </div>
        </div>
  
        
        );
    }
}

CategoryList.propTypes = {
  itemList: PropTypes.any,
  clearCheckList: PropTypes.func,
  redirectPage: PropTypes.func 
} 
export default CategoryList;